// EnrollDataContainer.jsx

import React from "react";
import employerSvc from "../../../services/employer/employerSvc";
import EnrollData from "./EnrollData";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

function EnrollDataContainer({
  reliusWeb,
  employerId,
  empState,
  planTypes,
  plans,
  approvedVendors,
  employerName,
}) {
  // Debug flag - set to true to enable console logs
  const DEBUG_ROUTING = false;

  const debugLog = React.useCallback((message, data = null) => {
    if (DEBUG_ROUTING) {
      if (data) {
        console.log('EnrollDataContainer:', message, data);
      } else {
        console.log('EnrollDataContainer:', message);
      }
    }
  }, [DEBUG_ROUTING]);
  // Compute websiteName (mimicking SearchEnroll)
  const websiteName = React.useMemo(() => {
    let name = "TCG Services";
    const normalizedHost = window.location.host.replace(/^www\./, "");

    switch (normalizedHost) {
      case "tcgservices.com":
        name = "TCG Services";
        break;
      case "region10rams.org":
      case "test.region10rams.org":
        name = "Region 10 RAMS";
        break;
      case "calstrs403bcomply.com":
        name = "CALSTRS";
        break;
      case "finpath403b.com":
        name = "FinPath 403b";
        break;
      case "weabenefits.com":
        name = "WEA Benefits";
        break;
      default:
        break;
    }
    return name;
  }, []);

  debugLog('reliusWeb:', reliusWeb);
  const [finalReliusWeb, setFinalReliusWeb] = React.useState(
    reliusWeb || "retirement.tcgservices.com"
  );
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    // If reliusWeb wasn't passed, we attempt to fetch it
    if (!reliusWeb && employerId) {
      setIsLoading(true);
      employerSvc
        .getEmployersByWebsite({
          website: websiteName,
          page: "enrollSearch",
        })
        .then((employers) => {
          // Find the matching employer
          const foundEmployer = employers.find(
            (emp) => String(emp.id) === String(employerId)
          );
          setFinalReliusWeb(
            foundEmployer?.relius_web || "retirement.tcgservices.com"
          );
        })
        .catch((err) => {
          console.error("Error fetching reliusWeb fallback:", err);
          setFinalReliusWeb("retirement.tcgservices.com");
        })
        .finally(() => setIsLoading(false));
    }
  }, [reliusWeb, employerId, websiteName]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <EnrollData
      planTypes={planTypes}
      plans={plans}
      employerName={employerName}
      approvedVendors={approvedVendors}
      empState={empState}
      employerId={employerId}
      reliusWeb={finalReliusWeb}
    />
  );
}

export default EnrollDataContainer;
